import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface PaymentMethodProps {
  title: string;
  description: string;
  icon: ReactNode;
  selected: boolean;
  onClick: () => void;
  children?: ReactNode;
}
const PaymentMethod: React.FC<PaymentMethodProps> = ({
  title,
  description,
  icon,
  selected,
  onClick,
  children
}) => {
  return <div className={`border rounded-lg p-4 cursor-pointer transition ${selected ? 'border-green-600 bg-green-50' : 'border-gray-200 hover:border-green-300'}`} onClick={onClick} data-id="element-406">
      <div className="flex items-center justify-between" data-id="element-407">
        <div className="flex items-center" data-id="element-408">
          <div className="mr-3" data-id="element-409">{icon}</div>
          <div data-id="element-410">
            <h3 className="font-medium" data-id="element-411">{title}</h3>
            <p className="text-sm text-gray-600" data-id="element-412">{description}</p>
          </div>
        </div>
        <div className={`w-6 h-6 rounded-full border flex items-center justify-center ${selected ? 'border-green-600 bg-green-600' : 'border-gray-300'}`} data-id="element-413">
          {selected && <CheckCircleIcon size={16} className="text-white" data-id="element-414" />}
        </div>
      </div>
      {selected && children}
    </div>;
};
export default PaymentMethod;